import { render, staticRenderFns } from "./SchoolContractPanel.vue?vue&type=template&id=1f938acc&scoped=true&"
import script from "./SchoolContractPanel.vue?vue&type=script&lang=js&"
export * from "./SchoolContractPanel.vue?vue&type=script&lang=js&"
import style0 from "./SchoolContractPanel.vue?vue&type=style&index=0&id=1f938acc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f938acc",
  null
  
)

export default component.exports